<template>
  <article class="person-box">
    <div class="person-box__content">
      <div v-if="photo" class="person-box__photo-wrap">
        <div
          :style="{ backgroundImage: `url(${ photo }` }"
          class="person-box__photo"
        />
      </div>
      <hgroup class="person-box__headings">
        <h3 class="person-box__heading">{{ name }}</h3>
        <h4 class="person-box__sub-heading">{{ position }}</h4>
      </hgroup>
      <p v-html="description" class="person-box__description"/>
    </div>
    <footer class="person-box__footer">
      <div v-if="phone" class="person-box__footer-item">
        <span class="person-box__divider">–</span>
        <a :href="`tel:${ phone }`" class="person-box__footer-link">
          {{ phone }}
        </a>
      </div>
      <div v-if="email" class="person-box__footer-item">
        <span class="person-box__divider">–</span>
        <a :href="`mailto:${ email }`" class="person-box__footer-link">
          {{ email }}
        </a>
      </div>
    </footer>
  </article>
</template>

<script>
export default {
  props: {
    photo: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    position: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    phone: {
      type: String,
      default: ''
    },
    email: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
  .person-box {
    @include vertical-space((bottom: 2), padding);
    @include equal-height-column;

    &__photo-wrap {
      @include vertical-space((top: 1, bottom: 1), padding);
      margin-top: -8px;
    }

    &__photo {
      @include cover-background;
      width: 250px;
      height: 250px;
    }

    &__sub-heading {
      @include text(big, medium);
      @include vertical-space((bottom: 1));
    }

    &__description {
      @include text;
      @include vertical-space((bottom: 1));
    }

    &__footer {
      @include text;
    }

    &__divider {
      display: block;
    }

    &__footer-link {
      @include reset-link;
      transition: color $base-transition;

      &:hover {
        @include theme-opposite(color);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/Team/PersonBox.vue